import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store/user'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import { i18n } from './assets/lang/index'
import "@/utils/xdate";
// css
import '@/assets/css/main.css';
import '@/assets/css/index.less'
import '@/assets/css/base.less'
//动画库
import 'animate.css';
//第三方数据管理仓库
import { createPinia } from 'pinia'

// import dayjs from 'dayjs';
// import 'dayjs/locale/zh-cn';
// dayjs.locale('zh-cn');

//字体
import "@/font/font.less"
// 字符串处理类库
import voca from 'voca';
window.v = voca


const app = createApp(App)
    // app.use(store)
app.use(router)
app.use(createPinia())
app.use(i18n)
app.use(Antd)
app.mount('#app')